export function degToRad(deg) {
    return (deg * Math.PI) / 180;
}
export function radToDeg(rad) {
    return (rad * 180) / Math.PI;
}
export function normalizeAngle(angle) {
    return Math.atan2(Math.sin(angle), Math.cos(angle));
}
